import { render, staticRenderFns } from "./RegionInfoPop.vue?vue&type=template&id=24bb7099&scoped=true&"
import script from "./RegionInfoPop.vue?vue&type=script&lang=js&"
export * from "./RegionInfoPop.vue?vue&type=script&lang=js&"
import style0 from "./RegionInfoPop.vue?vue&type=style&index=0&id=24bb7099&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb7099",
  null
  
)

export default component.exports